import Heading from "@components/Booking/Heading";
import {Trans, useTranslation} from "@i18n/client";
import React from "react";
import {I18nNamespace} from "@i18n";

type HeaderProps = {
  apptReasonName?: string | null;
};

const Header = ({apptReasonName}: HeaderProps): JSX.Element => {
  const i18n = useTranslation(I18nNamespace.WEB_SCHEDULING);
  const i18nDB = useTranslation(I18nNamespace.DB);

  return (
    <Heading>
      {apptReasonName ? (
        // DEPRECATED: Please do not copy the patterns here for Trans. We should not be
        //  passing i18nKey, values, components, instead use children and put the actual JSX
        /*"book-an-appointment-for": "Book an appointment <br/><s>for {{apptReasonName}}</s>"*/
        <Trans
          ns="web-scheduling"
          i18nKey="book-an-appointment-for"
          values={{apptReasonName: i18nDB.t(apptReasonName, {ns: I18nNamespace.DB})}}
          components={{br: <br />, s: <span className="lowercase" />}}
        />
      ) : (
        // There _should_ be an apptReasonName here, unless there was some network error.
        // This is just a worst-case fallback.
        <>{i18n.t("Book an appointment", {ns: "web-scheduling"})}</>
      )}
    </Heading>
  );
};

export default React.memo(Header);
